import { cmxTypeguards, commonEnums } from '@codametrix/ui-common';
const { ChargeSessionCodeType } = commonEnums;

const CODE_ORDER = new Map<string, number>([
  [ChargeSessionCodeType.PROCEDURE.toUpperCase(), 0],
  [ChargeSessionCodeType.MODIFIER.toUpperCase(), 1],
  [ChargeSessionCodeType.DIAGNOSIS.toUpperCase(), 2]
]);

const getDroppableConfig = (
  dropCandidate: any,
  dropTarget: any,
  position: string,
  allItems: any[]
) => {
  // check to see if they're the next in line.
  const candidateOrder = CODE_ORDER.get(dropCandidate.codeType.toUpperCase());
  const targetOrder = CODE_ORDER.get(dropTarget.codeType.toUpperCase());
  const targetDifference = Math.abs(candidateOrder - targetOrder);
  let permissibleDifference = 1;

  if (targetDifference > 1) {
    const hasMods = allItems.some(
      item => item.data.codeType === ChargeSessionCodeType.MODIFIER
    );
    if (!hasMods) {
      permissibleDifference++;
    }
  }

  const rightAfter =
    position === 'after' &&
    candidateOrder === targetOrder + permissibleDifference;
  const rightBefore =
    position === 'before' &&
    candidateOrder === targetOrder - permissibleDifference;

  return { rightAfter, rightBefore };
};

const canDropOnto = (
  dropCandidate: any,
  dropTarget: any,
  position: string,
  allItems: any[]
) => {
  // test to see if it's a search result
  if (cmxTypeguards.isSearchResult(dropCandidate)) {
    // if they're of the same code type, then can drop
    // NOTE codeType and provenance are being tested here
    // search results and codes don't respect the same
    // definitions, so we have to compare two separate props
    const sameType = dropCandidate.codeType === dropTarget.provenance;
    if (sameType) {
      return true;
    }
  } else {
    // not supporting moving between lists yet.
    const inList = allItems.find(item => item.data.code === dropCandidate.code);
    if (!inList) {
      return false;
    }
    // if they're of the same code type, then can drop
    // dropping on self is prevented in the accordion
    const sameCodeType = dropCandidate.codeType === dropTarget.codeType;
    if (sameCodeType) {
      return true;
    }
  }
  // for search results and reordering
  const { rightAfter, rightBefore } = getDroppableConfig(
    dropCandidate,
    dropTarget,
    position,
    allItems
  );

  const targets = allItems
    .map(item => item.data)
    .filter(item => item.codeType === dropTarget.codeType);

  if (rightAfter) {
    return (
      targets.findIndex(item => item.code === dropTarget.code) ===
      targets.length - 1
    );
  } else if (rightBefore) {
    return targets[0].code === dropTarget.code;
  } else {
    return false;
  }
};

export { canDropOnto, CODE_ORDER };
